var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Hero',{attrs:{"title":"Jogadores","message":"Gestão de jogadores da equipa.","icon":"mdi-account-multiple","action":"withAction","layout_type":"users"}}),_c('v-container',{staticClass:"negative-margin"},[_c('Snackbar'),_c('TableUser')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }